import * as PIXI from 'pixi.js';
  import { populate } from 'populate';


const raw = /* 4@4!8|raw|8!4@ */ {
  list: [
    {
      id: '07ef257d-cac7-4645-85d1-0e8dfaee1e39',
      type: 'Container',
      name: 'root',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: ''
    },
    {
      id: '7364224e-f8a8-4fcf-847e-160c062d3d84',
      type: 'Text',
      name: 'label',
      className: '',
      x: 342,
      y: 30,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: '1',
      localize: false,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 28,
        fontWeight: 'normal',
        fontFamily: 'Futura-Bold',
        fill: 'white',
        stroke: 'black',
        strokeThickness: 4,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 4,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'miter',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: '07ef257d-cac7-4645-85d1-0e8dfaee1e39'
    },
    {
      id: '230d6d6b-010a-4eb9-a695-c9015c201471',
      type: 'Container',
      name: '',
      className: '',
      x: 0,
      y: 20,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '07ef257d-cac7-4645-85d1-0e8dfaee1e39'
    },
    {
      id: 'c6825923-2ddd-4ba9-9af0-1cf1edae0556',
      type: 'Sprite',
      name: '',
      className: '',
      x: 32,
      y: 15,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: '0_bubble_red',
      parent: '230d6d6b-010a-4eb9-a695-c9015c201471'
    },
    {
      id: '822bf931-4777-4c85-99e9-53bdfa1fe5ae',
      type: 'Sprite',
      name: '',
      className: 'stars',
      x: 139,
      y: 12,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: '0_bubble_grey',
      parent: '230d6d6b-010a-4eb9-a695-c9015c201471'
    },
    {
      id: '660fa92e-7a76-4195-9ebd-0be6f39a3eae',
      type: 'Sprite',
      name: '',
      className: 'stars',
      x: 254,
      y: 10,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: '0_bubble_blue',
      parent: '230d6d6b-010a-4eb9-a695-c9015c201471'
    }
  ],
  x: 50,
  y: 0,
  width: 640,
  height: 960,
  handleResize: true
}; /* 4@4!8|raw|8!4@ */

type Filter = Partial<{
  root: boolean;
  label: boolean;
  stars: (PIXI.Sprite)[];
}>;

class Layout {
  public readonly root: PIXI.Container;
  public readonly label: PIXI.Text;
  public readonly stars: (PIXI.Sprite)[] = [];

  constructor(filter?: Filter) {
    populate(this, raw, filter);
  }
}

export { Layout, Filter, raw };
